export function dataTestId(type: 'permission' | 'setting', label: string) {
  return `${type}-${label.toLowerCase().replaceAll(' ', '-')}`;
}
